interface Props {
  onClick: () => void;
}
const SvgToastClose: React.FC<Props> = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: "pointer" }}
    >
      <g clipPath="url(#clip0_23244_28469)">
        <path
          d="M14.8074 2.61698C14.6588 2.62049 14.5177 2.68263 14.4148 2.78983L9 8.20462L3.5852 2.78983C3.53277 2.73584 3.47004 2.69291 3.40072 2.6636C3.3314 2.63428 3.2569 2.61918 3.18164 2.61918C3.06969 2.6192 2.9603 2.65263 2.86746 2.71518C2.77461 2.77772 2.70254 2.86655 2.66047 2.97028C2.61839 3.07402 2.60822 3.18795 2.63126 3.2975C2.6543 3.40705 2.70949 3.50724 2.78979 3.58524L8.20459 9.00004L2.78979 14.4148C2.73581 14.4667 2.69271 14.5287 2.66302 14.5974C2.63333 14.6661 2.61764 14.7401 2.61688 14.8149C2.61612 14.8897 2.6303 14.964 2.65859 15.0333C2.68687 15.1025 2.7287 15.1655 2.78162 15.2184C2.83454 15.2713 2.89749 15.3132 2.96677 15.3414C3.03606 15.3697 3.11029 15.3839 3.18513 15.3832C3.25996 15.3824 3.33389 15.3667 3.40259 15.337C3.47129 15.3073 3.53337 15.2642 3.5852 15.2102L9 9.79545L14.4148 15.2102C14.4666 15.2642 14.5287 15.3073 14.5974 15.337C14.6661 15.3667 14.74 15.3824 14.8149 15.3831C14.8897 15.3839 14.9639 15.3697 15.0332 15.3414C15.1025 15.3132 15.1655 15.2713 15.2184 15.2184C15.2713 15.1655 15.3131 15.1025 15.3414 15.0333C15.3697 14.964 15.3839 14.8897 15.3831 14.8149C15.3823 14.7401 15.3667 14.6661 15.337 14.5974C15.3073 14.5287 15.2642 14.4667 15.2102 14.4148L9.79541 9.00004L15.2102 3.58524C15.292 3.50673 15.3482 3.40534 15.3713 3.29435C15.3945 3.18337 15.3836 3.06797 15.3401 2.96329C15.2965 2.85861 15.2223 2.76953 15.1273 2.70773C15.0322 2.64593 14.9207 2.6143 14.8074 2.61698Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_23244_28469">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgToastClose;
